import './style.scss'
export const editTablePopoverRef = 'editTablePopoverRef'
export default {
  functional: true,
  render(h, context) {
    const props = context.props
    const popoverAttrs = {
      props: {
        placement: 'bottom-start',
        trigger: 'manual',
        popperClass: 'kye-plugin-popper kye-plugin-popover-dark',
        ...(props.popoverProps || {})
      },
      ref: editTablePopoverRef
    }
    return <el-popover {...popoverAttrs}>{props.popper && props.popper()}</el-popover>
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-edit-table/popover/components.js